import API from "../../../store/api";
import { authLogout } from "../../../store/actions/authActions";
import { setPrnd, clearPrnd } from "../../../store/actions/prndActions";
import { setMessage } from '../../../store/actions/dialogActions';

export const getAllPrnd = (bearerAuth) => {
  return async dispatch => {
    API.get("/api/portal/prnd")
      .set('Authorization', `Bearer ${bearerAuth}`)
      .ok(res => res.status < 500) // anything under 500 handled in code, 500+ thrown as exception
      .then((response) => {
        if (response.status === 200) {
          dispatch(setPrnd(response.body))
        } else if (response.status === 401) {
          dispatch(clearPrnd);
          dispatch(authLogout);
        } else {
          dispatch(clearPrnd);
        }
      }).catch((error) => {
        let message = 'An error has occurred';
        if (error.message) {
          message = error.message;
        }
        if (error.response && error.response.body) {
          if (error.response.body.messages) {
            message = error.response.body.messages.toString();
          } 
        }
        dispatch(setMessage({
          title: 'PRND Retrieval Failed',
          message: message,
          type: 'ERR',
        }))
        dispatch(clearPrnd);
      })
  }
}